import { CustomQueryOptions, QueryKeys, useCustomQuery } from './index';
import Config from '../../config';
import { YesNoFlag } from '../types';
import { assignmentTypes, shortTypes } from '../authorization/assignmentTypes';
import { ALL_ASSIGNMENTS_CODE } from '../../userSettings/constants';

export type BaseCreateRole = {
  roleName: string,
  description?: string,
  clientId?: number,
  allowDelete: YesNoFlag,
  allowEdit: YesNoFlag,
}

export type BaseRole = BaseCreateRole & {
  roleId: number,
}

export type Assignment = {
  assignmentType: assignmentTypes,
  assignmentCode: string,
  privileges: { privilegeCode: string }[],
}


type RawRole = BaseRole & {
  roleAssignments?: Assignment[]
};

export const useRoles = () => useCustomQuery<RawRole[]>(
  QueryKeys.roles.RolesList,
  {
    url: Config.endpoints.FETCH_ROLES,
    errorMessage: 'Fetching roles failed',
    defaultData: [],
  }
);

export const useRoleData = ({ roleId }: { roleId: string }, { onSuccess }: { onSuccess: CustomQueryOptions<RawRole, Error>['onSuccess'] }) =>
  useCustomQuery<RawRole>(
    [QueryKeys.roles.RoleData, roleId],
    {
      url: Config.endpoints.FETCH_ROLE_ASSIGNMENTS
        .replace(/:roleId/, roleId),
      errorMessage: 'Fetching role data failed',
      onSuccess,
      enabled: Boolean(roleId),
      select: role => ({
        ...role,
        roleAssignments: role.roleAssignments?.map(assignment =>
          assignment.assignmentType !== shortTypes.AL
            ? assignment
            : {
              ...assignment,
              assignmentCode: ALL_ASSIGNMENTS_CODE,
            }
        ),
      }),
    }
  );

export const useRoleCheckPrivilege = (privilege: string) => useCustomQuery<boolean>(
  [QueryKeys.roles.RoleCheckPrivilege],
  {
    url: Config.endpoints.FETCH_ROLE_USER_PRIVILEGES.replace(':userPrivilege', privilege),
    errorMessage: `Fetching check privilege ${privilege} failed`,
    defaultData: false,
  }
);
